module.exports = __webpack_public_path__ + "es.c3b1984fe87e7ae377ec.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/es.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/es.svg
// module chunks = styles